module.exports = __webpack_public_path__ + "media/bootstrap-icons/binoculars-5896bfee.svg";